export default "__VITE_ASSET__DYQsh0wd__"